import React from 'react'
import { browserHistory } from 'react-router'
import './index.scss'
import CompteBurger from '../../Page/Compte/Component/Compte/Compte'

import MenuBar from '../Menu'

import Index from '../Header/index'
import Grid from '@material-ui/core/Grid'
import { withSnackbar } from 'notistack'

import dllData from '../../../Utilitaire/Data/Download'
import { connectWS, isWebSocketConnected, WebSocketDisconnect } from '../../../Utilitaire/Websocket/index'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import Connection from '../../Page/Connection/index'

import Utils from 'EurestoFonction/Utils'

const project = require('EurestoConfig/project.config')

const secondDivStyle = { display: 'none' }

export class PageLayout extends React.Component {

  constructor(props) {
    super(props)
    User.Disconnect.set(this.connection)
    if (this.props.location.query.isConnectedAs) {
      sessionStorage.setItem('isConnectedAs', this.props.location.query.isConnectedAs)
    }
    if (sessionStorage.getItem('isConnectedAs') === 'true') {
      User.CalculHeight.setConnectedAs(true)
    }

    User.CalculHeight.setNavigation(this.props.location.query.navigation !== 'off')

    sessionStorage.setItem('navigation', this.props.location.query.navigation !== 'off')

    User.NotificationSystem.set((notification) => {
      const uuid = Utils.uuidv4()
      notification && notification.message && props.enqueueSnackbar(notification.message, {
        autoHideDuration: 2000,
        key: uuid,
        variant: notification.variant || 'success',
        action: (key) => (
          <i
            onClick={() => props.closeSnackbar(key)}
            style={{
              height: '100%',
              left: 0,
              position: 'absolute',
              top: 0,
              width: '100%',
            }} />
        )
      })
    })

    this.state = {
      showWebSite: 0,
      key: Utils.getRandomNumber(),
      navigation: this.props.location.query.navigation !== 'off',
      connectedAs: sessionStorage.getItem('isConnectedAs') === 'true'
    }

    browserHistory.push({
      pathname: this.props.location.pathname,
      state: { ...this.props.location.query }
    })

  }

  waitConnection = async _ => {
    await this.start()
    User.ColorWebSite.change()
    connectWS()
    this.setState({
      showWebSite: 1,
      key: Utils.getRandomNumber()
    })
  }

  componentDidMount() {
    if ((this.props.location.query.passwordForgot || (this.props.location.state && this.props.location.state.passwordForgot))) {
      this.setState({
        showWebSite: -2,
        key: Utils.getRandomNumber()
      })
    } else if (sessionStorage.getItem('token') === '' || sessionStorage.getItem('token') === undefined || sessionStorage.getItem('token') === null) {
      this.connection()
    } else {
      this.waitConnection()
    }
  }

  start = async () => {
    const r = await dllData()
    if (r !== undefined && r.code === -1) {
      this.setState({
        showWebSite: -3,
        key: Utils.getRandomNumber()
      })
    }
  }

  connection = async () => {
    if (isWebSocketConnected()) {
      WebSocketDisconnect()
    }
    /*for (let key in localStorage) {
      if (key.substring(0, 7) === 'search_' && parseInt(key.slice(-1)[0]) === User.Entite.get().id) {
        localStorage.removeItem(key)
      }
    }*/
    sessionStorage.setItem('token', '')
    localStorage.setItem('token', '')
    Data.clearAll()
    this.setState({
      showWebSite: -2,
      key: Utils.getRandomNumber()
    })
  }

  connectionChangeState = (token) => {
    localStorage.setItem('token', token)
    sessionStorage.setItem('token', token)
    this.setState({
      showWebSite: 0,
      key: Utils.getRandomNumber()
    }, this.waitConnection)
  }

  render() {
    if (this.state.showWebSite === -1) {
      return (
        <div>An error has occurred... Try again</div>
      )
    } else if (this.state.showWebSite === -3) {
      return (
        <div>You are not allow to connect to this application</div>
      )
    } else if (this.state.showWebSite === -2) {
      return (
        <Connection handler={this.connectionChangeState}
          passwordForgot={this.props.location && this.props.location && this.props.location.state && this.props.location.state.passwordForgot} />
      )
    } else {
      return (
        <div key={this.state.key} className='text-center' id="body-page">
          <div style={secondDivStyle}>
            <div className={'EurestoPrimary EurestoPrimary--text'} />
            <div className={'EurestoSecondary EurestoSecondary--text'} />
            <div className={'EurestoError EurestoError--text'} />
            <div className={'EurestoText EurestoText--text'} />
            <div className={'disabled'} />
          </div>
          {this.state.showWebSite === 0 && <Grid container spacing={0} style={{
            margin: 0,
            padding: 0,
            height: '100vh',
            zIndex: 1000,
            position: 'fixed',
            backgroundColor: this.state.showWebSite === 0 && '#99999988' || 'transparent',
          }} direction={'column'}
            justify="center"
            alignItems="center">
            {/*<CircularProgress size={100} thickness={4} className={'EurestoPrimary--text'}/>*/}
            <div id={'MainDivProgress'} style={{ position: 'relative' }}>
              <span className={'ei-logo_E EurestoPrimary--text'} style={
                {
                  position: 'relative',
                  fontSize: 190,
                  zIndex: 2
                }
              }>
              </span>
              <span className={'MainBlockProgress'} style={
                {
                  height: 145,
                  width: 150,
                  top: 24,
                  left: 50,
                  position: 'absolute',
                  border: '1px solid black',
                  zIndex: 1,
                  backgroundColor: 'transparent'
                }
              } />
              <span className={'MainBlockProgress2 EurestoSecondary'} id={'MainBlockProgress'} style={
                {
                  height: 143,
                  width: 0,
                  top: 25,
                  left: 51,
                  position: 'absolute',
                  zIndex: 1
                  //backgroundColor: 'transparent'
                }
              } />
            </div>
            <i className={'EurestoPrimary--text'} style={{ fontSize: 15 }}>Téléchargement de vos données en cours,
              veuillez patienter...</i>
          </Grid>}
          <div className={this.state.showWebSite === 0 && 'blur' || ''} style={{
            margin: 0,
            padding: 0,
            height: '100vh',
            position: 'fixed',
          }}>
            {this.state.navigation && <div>
              <div id="appAccount">
                <CompteBurger />
              </div>
              <Index />
              <MenuBar />
            </div>}
            <div id="a-page">
              <div className='page-layout__viewport' style={Object.assign({
                height: User.CalculHeight.getHeightWanted(),
                maxHeight: User.CalculHeight.getHeightWanted()
              }, this.state.navigation ? {
                paddingTop: '40px',
                minHeight: '100%',
                top: '40px'
              } : {})}>
                <div id="outer-container" style={{
                  height: User.CalculHeight.getHeightWanted(),
                  maxHeight: User.CalculHeight.getHeightWanted()
                }}>
                  <div id="page-wrap" style={{
                    height: User.CalculHeight.getHeightWanted(),
                    maxHeight: User.CalculHeight.getHeightWanted(),
                    width: '100vw',
                    position: 'relative',
                    //overflow: 'hidden',
                  }}>
                    {this.state.showWebSite !== 0 && this.props.children}
                  </div>
                  {this.state.connectedAs && <div style={{
                    height: 31,
                    position: 'absolute',
                    backgroundColor: 'lightgrey',
                    bottom: 0,
                    width: '100%',
                    borderTop: this.state.connectedAs && '2px solid rgba(0,0,0,0.50)' || 'none',
                    //borderTop: '1px solid rgba(255,255,255,0.20)'
                  }}>
                    <Grid container style={{ margin: 0, padding: 0, height: '100%' }} spacing={0} justify={'center'}
                      alignItems={'center'}>
                      Vous êtes connecté en tant que ~&nbsp;
                      <strong>{User && User.Entite && User.Entite.get() && User.Entite.get().libelle}</strong>
                      &nbsp;~ (<span style={{ textDecoration: 'underline' }} className={'cursor-pointer'}
                        onClick={() => self.close()}>Quitter</span>)
                    </Grid>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default withSnackbar(PageLayout)



// WEBPACK FOOTER //
// ./app/App/Static/Page/index.js